import {WriteButton} from '../../common/buttons/WriteActions';
import {Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField} from '@mui/material';
import {useState} from 'react';
import {ProductTypeGuidDto} from '../../../models/ProductTypes/IProductTypeGuid';
import {productTypesAPI} from '../../../services/ProductTypeServices';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';
import {getApiErrorMessage, getApiFieldErrors} from '../../../common/apiErrors';

interface Props {
    open: boolean;
    onClose: () => void;
    onCreated?: (productType: ProductTypeGuidDto) => void;
}

export const CreateProductTypeDialog = ({open, onClose, onCreated}: Props) => {
    const {t} = useAppTranslation();
    const [name, setName] = useState('');
    const [error, setError] = useState<unknown>();
    const [createProductType, {isLoading}] = productTypesAPI.useCreateProductTypeV2Mutation();

    const save = async () => {
        const trimmedName = name.trim();
        if (!trimmedName) return;

        try {
        const productType = await createProductType({
            name: trimmedName,
            recipes: [],
            packages: [],
            priceTiers: [],
        }).unwrap();
        setName('');
        onCreated?.(productType);
        if (!onCreated) onClose();
        } catch (requestError) {
            setError(requestError);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <DialogTitle>{t('recipes:new_product_type')}</DialogTitle>
            <DialogContent>
                <>
                {Boolean(error) && !getApiFieldErrors(error, t).name && <Alert severity="error">{getApiErrorMessage(error, t)}</Alert>}
                <TextField
                    autoFocus
                    fullWidth
                    margin="dense"
                    label={t('recipes:name')}
                    value={name}
                    onChange={(event) => { setName(event.target.value); setError(undefined); }}
                    error={!!error && !!getApiFieldErrors(error, t).name}
                    helperText={error ? getApiFieldErrors(error, t).name : undefined}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') void save();
                    }}
                />
                </>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('common:cancel')}</Button>
                <WriteButton variant="contained" onClick={() => void save()} disabled={!name.trim() || isLoading}>{t('common:create')}</WriteButton>
            </DialogActions>
        </Dialog>
    );
};
